import activityCardHeader from 'components/ActivityCard/components/ActivityCardHeader/translations/english';
import applicationActivityList from 'components/ApplicationActivityList/translations/english';
import applicationsGridRow from 'components/ApplicationsGrid/components/ApplicationsGridRow/translations/english';
import applicationsGrid from 'components/ApplicationsGrid/translations/english';
import assetsGridRow from 'components/AssetsGrid/components/AssetsGridRow/translations/english';
import assetsGrid from 'components/AssetsGrid/translations/english';
import boundariesGrid from 'components/BoundariesGrid/translations/english';
import chemicalCard from 'components/ChemicalCard/translations/english';
import chemicalSearchPanel from 'components/ChemicalSearchPanel/translations/english';
import chemicalsGrid from 'components/ChemicalsGrid/translations/english';
import clientGrid from 'components/ClientGrid/translations/english';
import combobox from 'components/Combobox/translations/english';
import compatibilityAdvisoryPanel from 'components/CompatibilityAdvisoryPanel/translations/english';
import complianceRow from 'components/ComplianceRow/translations/english';
import confirmationModal from 'components/ConfirmationModal/translations/english';
import dataTableDropdown from 'components/DataTableDropdown/translations/english';
import dateRangePickerInputs from 'components/DateRangePicker/components/DateRangePickerInputs/translations/english';
import dateRangePicker from 'components/DateRangePicker/translations/english';
import detailsViewCardApplicationList from 'components/DetailsViewCardApplicationList/translations/english';
import detailsViewCardApplicationListItem from 'components/DetailsViewCardApplicationListItem/translations/english';
import detailsViewCloseButton from 'components/DetailsViewCloseButton/translations/english';
import detailsViewEntityMenu from 'components/DetailsViewEntityMenu/translations/english';
import drawer from 'components/Drawer/translations/english';
import exportDropdown from 'components/ExportDropdown/translations/english';
import farmsGrid from 'components/FarmsGrid/translations/english';
import fieldsGrid from 'components/FieldsGrid/translations/english';
import flightsGridRow from 'components/FlightsGrid/components/FlightsGridRow/translations/english';
import flightsGrid from 'components/FlightsGrid/translations/english';
import floatingResourceAddMenu from 'components/FloatingResourceAddMenu/translations/english';
import formDiscardConfirmationPanel from 'components/FormDiscardConfirmationPanel/translations/english';
import formErrors from 'components/FormSubmitPanel/translations/english';
import logo from 'components/Logo/translations/english';
import lowGpaConcentrationWarning from 'components/LowGpaConcentrationWarning/translations/english';
import validateDrawing from 'components/Map/hooks/useDrawingTool/hooks/useValidateDrawing/translations/english';
import map from 'components/Map/translations/english';
import mapBoundaryPopover from 'components/MapBoundaryPopover/translations/english';
import mapControlPopup from 'components/MapControlPopup/translations/english';
import mapControlResetPopup from 'components/MapControlResetPopup/translations/english';
import drawingModeDropdown from 'components/MapHorizontalControlBar/components/DrawingModeDropdown/translations/english';
import drawingToolDropdown from 'components/MapHorizontalControlBar/components/DrawingToolDropdown/translations/english';
import pointModeDropdown from 'components/MapHorizontalControlBar/components/PointModeDropdown/translations/english';
import mapHorizontalControlBar from 'components/MapHorizontalControlBar/translations/english';
import mixOrderAdvisoryPanel from 'components/MixOrderAdvisoryPanel/translations/english';
import mixesGrid from 'components/MixesGrid/translations/english';
import mobileDrawerMenuButton from 'components/MobileDrawerMenuButton/translations/english';
import modal from 'components/Modal/translations/english';
import multiSelectPanel from 'components/MultiSelectPanel/translations/english';
import navigation from 'components/Navigation/translations/english';
import onboardingStepCount from 'components/OnboardingStepCount/translations/english';
import onboardingTopBar from 'components/OnboardingTopBar/translations/english';
import orderBadge from 'components/OrderBadge/translations/english';
import organizationDropdown from 'components/OrganizationDropdown/translations/english';
import sameAiWarningBanner from 'components/SameAiWarningBanner/translations/english';
import searchResultItem from 'components/SearchResultItem/translations/english';
import selectPanel from 'components/SelectPanel/translations/english';
import selectableGrid from 'components/SelectableGrid/translations/english';
import singleDatePicker from 'components/SingleDatePicker/translations/english';
import singleSelectPanel from 'components/SingleSelectPanel/translations/english';
import sourceBadge from 'components/SourceBadge/translations/english';
import usersGrid from 'components/UsersGrid/translations/english';
import withSplitView from 'components/WithSplitView/translations/english';
import addButton from 'components/buttons/AddButton/translations/english';
import floatingResourceContainerFooter from 'components/containers/FloatingResourceContainerFooter/translations/english';
import onboardingFormContainer from 'components/containers/OnboardingFormContainer/translations/english';
import addressOneField from 'components/fields/AddressOneField/translations/english';
import addressTwoField from 'components/fields/AddressTwoField/translations/english';
import applicationNameField from 'components/fields/ApplicationNameField/translations/english';
import applicationSelectPanelField from 'components/fields/ApplicationSelectPanelField/translations/english';
import batteryMultiSelectPanelField from 'components/fields/BatteryMultiSelectPanelField/translations/english';
import batteryNameField from 'components/fields/BatteryNameField/translations/english';
import batterySerialNumberField from 'components/fields/BatterySerialNumberField/translations/english';
import boundaryNameField from 'components/fields/BoundaryNameField/translations/english';
import boundarySelectPanelField from 'components/fields/BoundarySelectPanelField/translations/english';
import chemicalMixSelectPanelField from 'components/fields/ChemicalMixSelectPanelField/translations/english';
import cityField from 'components/fields/CityField/translations/english';
import clientComboBoxField from 'components/fields/ClientComboBoxField/translations/english';
import clientNameField from 'components/fields/ClientNameField/translations/english';
import clientSelectPanelField from 'components/fields/ClientSelectPanelField/translations/english';
import contactNameField from 'components/fields/ContactNameField/translations/english';
import droneMultiSelectPanelField from 'components/fields/DroneMultiSelectPanelField/translations/english';
import droneNameField from 'components/fields/DroneNameField/translations/english';
import emailAddressField from 'components/fields/EmailAddressField/translations/english';
import faaNumberField from 'components/fields/FaaNumberField/translations/english';
import farmNameField from 'components/fields/FarmNameField/translations/english';
import farmSelectPanelField from 'components/fields/FarmSelectPanelField/translations/english';
import fieldNameField from 'components/fields/FieldNameField/translations/english';
import fieldSelectPanelField from 'components/fields/FieldSelectPanelField/translations/english';
import firstNameField from 'components/fields/FirstNameField/translations/english';
import lastNameField from 'components/fields/LastNameField/translations/english';
import multiSelectBatteryField from 'components/fields/MultiSelectBatteryField/translations/english';
import multiSelectDroneField from 'components/fields/MultiSelectDroneField/translations/english';
import multiSelectPilotField from 'components/fields/MultiSelectPilotField/translations/english';
import multiSelectRoleField from 'components/fields/MultiSelectRoleField/translations/english';
import organizationNameField from 'components/fields/OrganizationNameField/translations/english';
import phoneNumberField from 'components/fields/PhoneNumberField/translations/english';
import pilotMultiSelectPanelField from 'components/fields/PilotMultiSelectPanelField/translations/english';
import roleMultiSelectPanelField from 'components/fields/RoleMultiSelectPanelField/translations/english';
import selectApplicationField from 'components/fields/SelectApplicationField/translations/english';
import selectBoundaryField from 'components/fields/SelectBoundaryField/translations/english';
import selectChemicalMixField from 'components/fields/SelectChemicalMixField/translations/english';
import selectClientFarmField from 'components/fields/SelectClientFarmField/translations/english';
import selectClientFarmFieldField from 'components/fields/SelectClientFarmFieldField/translations/english';
import selectClientField from 'components/fields/SelectClientField/translations/english';
import selectFarmField from 'components/fields/SelectFarmField/translations/english';
import selectFieldField from 'components/fields/SelectFieldField/translations/english';
import statesDropdownField from 'components/fields/StatesDropdownField/translations/english';
import zipCodeField from 'components/fields/ZipCodeField/translations/english';
import addressForm from 'components/forms/AddressForm/translations/english';
import applicationFormFields from 'components/forms/ApplicationFormFields/translations/english';
import batteryFormFields from 'components/forms/BatteryFormFields/translations/english';
import boundaryFormFields from 'components/forms/BoundaryFormFields/translations/english';
import clientFormFields from 'components/forms/ClientFormFields/translations/english';
import createApplicationForm from 'components/forms/CreateApplicationForm/translations/english';
import createAssetForm from 'components/forms/CreateAssetForm/translations/english';
import createBatteryForm from 'components/forms/CreateBatteryForm/translations/english';
import createBoundaryForm from 'components/forms/CreateBoundaryForm/translations/english';
import createClientForm from 'components/forms/CreateClientForm/translations/english';
import createDroneForm from 'components/forms/CreateDroneForm/translations/english';
import createFarmForm from 'components/forms/CreateFarmForm/translations/english';
import createFieldForm from 'components/forms/CreateFieldForm/translations/english';
import droneFormFields from 'components/forms/DroneFormFields/translations/english';
import farmFormFields from 'components/forms/FarmFormFields/translations/english';
import fieldFormFields from 'components/forms/FieldFormFields/translations/english';
import inviteUserForm from 'components/forms/InviteUserForm/translations/english';
import updateApplicationForm from 'components/forms/UpdateApplicationForm/translations/english';
import updateBatteryForm from 'components/forms/UpdateBatteryForm/translations/english';
import updateBoundaryForm from 'components/forms/UpdateBoundaryForm/translations/english';
import updateClientForm from 'components/forms/UpdateClientForm/translations/english';
import updateDroneForm from 'components/forms/UpdateDroneForm/translations/english';
import updateFarmForm from 'components/forms/UpdateFarmForm/translations/english';
import updateFieldForm from 'components/forms/UpdateFieldForm/translations/english';
import updateUserForm from 'components/forms/UpdateUserForm/translations/english';
import userFormFields from 'components/forms/UserFormFields/translations/english';
import errorNotification from 'components/notifications/ErrorNotification/translations/english';
import errorBoundary from 'components/providers/ErrorBoundary/translations/english';
import applicationsTable from 'components/tables/ApplicationsTable/translations/english';
import assetsTable from 'components/tables/AssetsTable/translations/english';
import boundariesTable from 'components/tables/BoundariesTable/translations/english';
import clientsTable from 'components/tables/ClientsTable/translations/english';
import fieldsTable from 'components/tables/FieldsTable/translations/english';
import usersTable from 'components/tables/UsersTable/translations/english';

import useAiLoadAdvisory from 'hooks/useAiLoadAdvisory/translations/english';
import useApplication from 'hooks/useApplication/translations/english';
import useApplicationMix from 'hooks/useApplicationMix/translations/english';
import useApplications from 'hooks/useApplications/translations/english';
import useAssets from 'hooks/useAssets/translations/english';
import useBatteries from 'hooks/useBatteries/translations/english';
import useBattery from 'hooks/useBattery/translations/english';
import useBoundaries from 'hooks/useBoundaries/translations/english';
import useBoundary from 'hooks/useBoundary/translations/english';
import useChemical from 'hooks/useChemical/translations/english';
import useChemicalSearch from 'hooks/useChemicalSearch/translations/english';
import useClient from 'hooks/useClient/translations/english';
import useClients from 'hooks/useClients/translations/english';
import useCompatibilityAdvisory from 'hooks/useCompatibilityAdvisory/translations/english';
import useCustomProduct from 'hooks/useCustomProduct/translations/english';
import useCustomProducts from 'hooks/useCustomProducts/translations/english';
import useDrone from 'hooks/useDrone/translations/english';
import useDrones from 'hooks/useDrones/translations/english';
import useFarm from 'hooks/useFarm/translations/english';
import useFarms from 'hooks/useFarms/translations/english';
import useFetch from 'hooks/useFetch/translations/english';
import useField from 'hooks/useField/translations/english';
import useFields from 'hooks/useFields/translations/english';
import useFlights from 'hooks/useFlights/translations/english';
import useFormulationReview from 'hooks/useFormulationReview/translations/english';
import useImports from 'hooks/useImports/translations/english';
import useMix from 'hooks/useMix/translations/english';
import useMixOrderAdvisory from 'hooks/useMixOrderAdvisory/translations/english';
import useMixRecipe from 'hooks/useMixRecipe/translations/english';
import useMixes from 'hooks/useMixes/translations/english';
import useOrganizations from 'hooks/useOrganizations/translations/english';
import usePrescription from 'hooks/usePrescription/translations/english';
import useUser from 'hooks/useUser/translations/english';
import useUsers from 'hooks/useUsers/translations/english';

import prescriptionSection from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/PrescriptionSection/translations/english';
import primaryParamsSection from 'pages/ApplicationDetailsPage/components/FlightPlannerPanel/components/PrimaryParamsSection/translations/english';
import johnDeereExportModal from 'pages/ApplicationDetailsPage/components/JohnDeereExportModal/translations/english';
import applicationDetailsPage from 'pages/ApplicationDetailsPage/translations/english';
import batteryDetailsPage from 'pages/BatteryDetailsPage/translations/english';
import boundaryDetailPage from 'pages/BoundaryDetailPage/translations/english';
import formulationReviewModal from 'pages/ChemicalDetailPage/components/FormulationReviewModal/translations/english';
import chemicalDetailPage from 'pages/ChemicalDetailPage/translations/english';
import chemicalsPage from 'pages/ChemicalsPage/translations/english';
import clientDetailsPage from 'pages/ClientDetailsPage/translations/english';
import connectionsPage from 'pages/ConnectionsPage/translations/english';
import mixRateRow from 'pages/CreateMixPage/components/MixRateRow/translations/english';
import createMixPage from 'pages/CreateMixPage/translations/english';
import dataPage from 'pages/DataPage/translations/english';
import droneDetailsPage from 'pages/DroneDetailsPage/translations/english';
import farmDetailsPage from 'pages/FarmDetailsPage/translations/english';
import fieldDetailsPage from 'pages/FieldDetailsPage/translations/english';
import johnDeereImport from 'pages/ImportPage/components/JohnDeereImport/translations/english';
import importPage from 'pages/ImportPage/translations/english';
import johnDeereCallbackPage from 'pages/JohnDeereCallbackPage/translations/english';
import maintenancePage from 'pages/MaintenancePage/translations/english';
import applicationContextSection from 'pages/MixApplyPage/components/ApplicationContextSection/translations/english';
import mixApplyHeader from 'pages/MixApplyPage/components/MixApplyHeader/translations/english';
import stateComplianceModal from 'pages/MixApplyPage/components/StateComplianceModal/translations/english';
import tankAndCarrierSection from 'pages/MixApplyPage/components/TankAndCarrierSection/translations/english';
import weatherConditionsSection from 'pages/MixApplyPage/components/WeatherConditionsSection/translations/english';
import mixApplyPage from 'pages/MixApplyPage/translations/english';
import mixDetailPage from 'pages/MixDetailPage/translations/english';
import onboardingCurrentUserPage from 'pages/OnboardingCurrentUserPage/translations/english';
import onboardingOrganizationCreationPage from 'pages/OnboardingOrganizationCreation/translations/english';
import prescriptionImportPage from 'pages/PrescriptionImportPage/translations/english';
import reportsPage from 'pages/ReportsPage/translations/english';
import userDetailsPage from 'pages/UserDetailsPage/translations/english';
import verifyEmailPage from 'pages/VerifyEmailPage/translations/english';

export const TRANSLATIONS_EN = {
    activityCardHeader,
    addButton,
    addressForm,
    addressOneField,
    addressTwoField,
    applicationActivityList,
    applicationContextSection,
    applicationDetailsPage,
    applicationFormFields,
    applicationNameField,
    applicationSelectPanelField,
    applicationsGrid,
    applicationsGridRow,
    applicationsTable,
    assetsGrid,
    assetsGridRow,
    assetsTable,
    batteryDetailsPage,
    batteryFormFields,
    batteryMultiSelectPanelField,
    batteryNameField,
    batterySerialNumberField,
    boundariesGrid,
    boundariesTable,
    boundaryDetailPage,
    boundaryFormFields,
    boundaryNameField,
    boundarySelectPanelField,
    chemicalCard,
    chemicalDetailPage,
    chemicalMixSelectPanelField,
    chemicalSearchPanel,
    chemicalsGrid,
    chemicalsPage,
    cityField,
    clientComboBoxField,
    clientDetailsPage,
    clientFormFields,
    clientGrid,
    clientNameField,
    clientSelectPanelField,
    clientsTable,
    combobox,
    compatibilityAdvisoryPanel,
    complianceRow,
    confirmationModal,
    connectionsPage,
    contactNameField,
    createApplicationForm,
    createAssetForm,
    createBatteryForm,
    createBoundaryForm,
    createClientForm,
    createDroneForm,
    createFarmForm,
    createFieldForm,
    createMixPage,
    dataPage,
    dataTableDropdown,
    dateRangePicker,
    dateRangePickerInputs,
    detailsViewCardApplicationList,
    detailsViewCardApplicationListItem,
    detailsViewCloseButton,
    detailsViewEntityMenu,
    drawer,
    drawingModeDropdown,
    drawingToolDropdown,
    droneDetailsPage,
    droneFormFields,
    droneMultiSelectPanelField,
    droneNameField,
    emailAddressField,
    errorBoundary,
    errorNotification,
    exportDropdown,
    faaNumberField,
    farmDetailsPage,
    farmFormFields,
    farmNameField,
    farmSelectPanelField,
    farmsGrid,
    fieldDetailsPage,
    fieldFormFields,
    fieldNameField,
    fieldSelectPanelField,
    fieldsGrid,
    fieldsTable,
    firstNameField,
    flightsGrid,
    flightsGridRow,
    floatingResourceAddMenu,
    floatingResourceContainerFooter,
    formDiscardConfirmationPanel,
    formErrors,
    formulationReviewModal,
    importPage,
    inviteUserForm,
    johnDeereCallbackPage,
    johnDeereExportModal,
    johnDeereImport,
    lastNameField,
    logo,
    lowGpaConcentrationWarning,
    maintenancePage,
    map,
    mapBoundaryPopover,
    mapControlPopup,
    mapControlResetPopup,
    mapHorizontalControlBar,
    mixApplyHeader,
    mixApplyPage,
    mixDetailPage,
    mixOrderAdvisoryPanel,
    mixRateRow,
    mixesGrid,
    mobileDrawerMenuButton,
    modal,
    multiSelectBatteryField,
    multiSelectDroneField,
    multiSelectPanel,
    multiSelectPilotField,
    multiSelectRoleField,
    navigation,
    onboardingCurrentUserPage,
    onboardingFormContainer,
    onboardingOrganizationCreationPage,
    onboardingStepCount,
    onboardingTopBar,
    orderBadge,
    organizationDropdown,
    organizationNameField,
    phoneNumberField,
    pilotMultiSelectPanelField,
    pointModeDropdown,
    prescriptionImportPage,
    prescriptionSection,
    primaryParamsSection,
    reportsPage,
    roleMultiSelectPanelField,
    sameAiWarningBanner,
    searchResultItem,
    selectApplicationField,
    selectBoundaryField,
    selectChemicalMixField,
    selectClientFarmField,
    selectClientFarmFieldField,
    selectClientField,
    selectFarmField,
    selectFieldField,
    selectPanel,
    selectableGrid,
    singleDatePicker,
    singleSelectPanel,
    sourceBadge,
    stateComplianceModal,
    statesDropdownField,
    tankAndCarrierSection,
    updateApplicationForm,
    updateBatteryForm,
    updateBoundaryForm,
    updateClientForm,
    updateDroneForm,
    updateFarmForm,
    updateFieldForm,
    updateUserForm,
    useAiLoadAdvisory,
    useApplication,
    useApplicationMix,
    useApplications,
    useAssets,
    useBatteries,
    useBattery,
    useBoundaries,
    useBoundary,
    useChemical,
    useChemicalSearch,
    useClient,
    useClients,
    useCompatibilityAdvisory,
    useCustomProduct,
    useCustomProducts,
    useDrone,
    useDrones,
    useFarm,
    useFarms,
    useFetch,
    useField,
    useFields,
    useFlights,
    useFormulationReview,
    useImports,
    useMix,
    useMixOrderAdvisory,
    useMixRecipe,
    useMixes,
    useOrganizations,
    usePrescription,
    useUser,
    useUsers,
    userDetailsPage,
    userFormFields,
    usersGrid,
    usersTable,
    validateDrawing,
    verifyEmailPage,
    weatherConditionsSection,
    withSplitView,
    zipCodeField
};
